import { useSelector } from "react-redux"
import { Navigate, useLocation } from "react-router-dom"

import {
  selectProfile,
  selectProfileLoaded,
  selectSubscription,
} from "../users/reducer"
import { getLandingPath } from "./components/sidebarLinkConfig"
import { getLegacySettingsRedirect } from "./settings/settingsTabs"

/**
 * "/" and "/dashboard": the landing page depends on the role, so wait for the
 * profile (CustomerLayout fetches it) before choosing.
 */
export function HomeRedirect() {
  const profile = useSelector(selectProfile)
  const profileLoaded = useSelector(selectProfileLoaded)
  const subscription = useSelector(selectSubscription)

  if (!profileLoaded) {
    return null
  }
  return <Navigate to={getLandingPath(profile, subscription)} replace />
}

/** Redirect that keeps the query string (e.g. /inbox?thread=1 -> /messages?thread=1). */
export function RedirectKeepingSearch({ to }) {
  const location = useLocation()
  return <Navigate to={`${to}${location.search}`} replace />
}

/** Old `/settings?tab=` values (inbox, billing, invoices, ...) redirect first. */
export function LegacySettingsRedirect({ children }) {
  const location = useLocation()
  const legacyRedirect = getLegacySettingsRedirect(location.search)
  if (legacyRedirect) {
    return <Navigate to={legacyRedirect} replace />
  }
  return children
}

/** Customer routes that only exist so old links and bookmarks keep working. */
export const CUSTOMER_REDIRECT_ROUTES = [
  {
    // Role-based landing: Activity, My Leads (concierges) or /texts.
    path: "",
    element: <HomeRedirect />,
  },
  {
    path: "dashboard/",
    element: <HomeRedirect />,
  },
  {
    // Reports is a tab on the Activity page now.
    path: "reports/",
    element: <Navigate to="/activity?tab=reports" replace />,
  },
  {
    // The inbox moved out of Settings into its own page.
    path: "inbox/",
    element: <RedirectKeepingSearch to="/messages" />,
  },
]

/** Index of /templates: email and SMS templates share one sidebar link. */
export const TEMPLATES_INDEX_ROUTE = {
  index: true,
  element: <Navigate to="/templates/email" replace />,
}
